/**
 * @generated SignedSource<<5232587b305589388685d9251f57fe3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user">;
  readonly " $fragmentType": "ProductBaseTile_user";
};
export type ProductBaseTile_user$key = {
  readonly " $data"?: ProductBaseTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "47f59224805204d16665ad8a858a6f8f";

export default node;
